import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";

export const clearError = () => {
  store.dispatch(Actions.CLEAR_ERROR);
};
